/*
 * PRD-037 — Layout PROPIO del portal del partner (app separada). Top-nav V4 + navegacion entre
 * paginas de gestion + Outlet. No depende del layout del panel.
 */
import { NavLink, Outlet } from 'react-router-dom';
import { usePartnerAuth } from './PartnerAuthContext';
import { C } from './ui';

const navItem = (active: boolean) => ({
  color: active ? C.white : '#B7C9D8',
  fontSize: 13,
  fontWeight: active ? 600 : 500,
  textDecoration: 'none',
  padding: '6px 2px',
  borderBottom: active ? `2px solid ${C.secondaryLight ?? C.secondary}` : '2px solid transparent',
});

const PartnerLayout = () => {
  const { partner, logout } = usePartnerAuth();
  return (
    <div style={{ minHeight: '100vh', background: C.pageBg, fontFamily: 'Poppins, sans-serif', color: C.primary }}>
      <header
        style={{
          background: C.primary,
          color: C.white,
          padding: '0 24px',
          height: 56,
          display: 'flex',
          alignItems: 'center',
          gap: 28,
        }}
      >
        <span style={{ fontWeight: 700, fontSize: 16, letterSpacing: '-0.01em' }}>
          Plick <span style={{ color: C.secondaryLight ?? C.secondary }}>Partners</span>
        </span>
        <nav style={{ display: 'flex', gap: 22, alignItems: 'center', flex: 1 }}>
          <NavLink to="/partner" end style={({ isActive }) => navItem(isActive)}>
            Inicio
          </NavLink>
          <NavLink to="/partner/comercios" style={({ isActive }) => navItem(isActive)}>
            Comercios
          </NavLink>
          <NavLink to="/partner/comercios/nuevo" style={({ isActive }) => navItem(isActive)}>
            Nuevo comercio
          </NavLink>
        </nav>
        <span style={{ fontSize: 13, color: '#B7C9D8' }}>{partner?.nombre || partner?.usuario}</span>
        <button
          type="button"
          onClick={logout}
          style={{
            fontFamily: 'Poppins, sans-serif',
            fontSize: 11,
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.03em',
            color: C.white,
            background: 'transparent',
            border: '1.5px solid #4F6373',
            borderRadius: 6,
            padding: '6px 14px',
            cursor: 'pointer',
          }}
        >
          Salir
        </button>
      </header>
      <main style={{ padding: '24px 16px' }}>
        <div style={{ maxWidth: 880, margin: '0 auto' }}>
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default PartnerLayout;
